<template>
    <header v-show="!(isSidebarOpen && windowWidth <= 768)"
        class="row mx-0 align-items-center main-header bg-blur app-header">
        <div class="logo col-auto p-0">
            <img src="../assets/logo_full.svg" alt="logo" height="50px" class="d-none d-md-flex" />
            <img src="../assets/logo_small.svg" alt="logo" height="50px" class="d-md-none" />
        </div>
        <div class="menu col-auto ms-auto position-relative p-0 gap-3 d-flex">
            <b-button @click="$emit('toggle-sidebar')" variant="link" class="ms-auto p-0 d-lg-none toggleSidebar"
                id="toggleSidebar">
                <b-icon icon="list"></b-icon>
            </b-button>

            <div v-if="user && !$global.hasRole('admin')">
                <span class="bg-primary text-white mr-2 p-2" id="switch-button"
                    v-for="(role, index) in _.filter(user.roles, (i) => i !== user.role && i !== 'admin')" :key="index"
                    @click="switchingRole(role)">
                    {{ $t('title.switchAs') }} {{ role }}
                </span>
            </div>

            <b-dropdown right>
                <template #button-content>
                    <div class="box image rounded-circle lang">
                        <b-icon icon="translate"></b-icon>
                    </div>
                </template>
                <b-dropdown-item class="notify-item" v-for="(entry, i) in languages" :key="`Lang${i}`" :value="entry"
                    @click="setLanguage(entry.language, entry.title)">
                    <span class="align-middle">{{ entry.title }}</span>
                </b-dropdown-item>
            </b-dropdown>

            <!-- User Dropdown -->
            <b-dropdown right v-if="user">
                <template #button-content>
                    <div class="box image rounded-circle">
                        <b-icon icon="person"></b-icon>
                    </div>
                </template>

                <router-link :to="{ name: 'Profile' }" class="dropdown-item">
                    <b-icon icon="gear"></b-icon>
                    {{ $t('title.editingMyProfile') }}
                </router-link>

                <router-link :to="{ name: 'ChangePassword' }" class="dropdown-item">
                    <b-icon icon="lock"></b-icon>
                    {{ $t('title.changePassword') }}
                </router-link>

                <b-dropdown-divider></b-dropdown-divider>
                <a href="javascript:void(0);" class="dropdown-item" v-b-modal.my-logout>
                    <b-icon icon="box-arrow-right"></b-icon>
                    {{ $t('title.exitFromSystem') }}
                </a>
            </b-dropdown>
            <b-modal id="my-logout" :title="$t('title.areYouSureWantToLogout')" no-close-on-backdrop no-close-on-esc
                @ok="handleSubmitLogout" :ok-title="$t('title.yes')" :cancel-title="$t('title.no')">
                <div class="my-3">
                    <div class="col-12">
                        <p class="fs-25">
                            <strong> {{ $t('title.areYouSureWantToLogout') }}</strong>
                        </p>
                    </div>
                </div>
            </b-modal>
        </div>
    </header>
</template>

<script>
import { getAuthUser, getStorage, hasRole, refresh, removeStorage, setStorage } from "@/Util/auth";
import { request } from "@/Util/Request";
import { mapGetters } from "vuex";

export default {
    name: 'AppHeader',
    computed: {
        ...mapGetters(['user']),
    },
    props: {
        isSidebarOpen: Boolean
    },
    data() {
        return {
            languages: [
                {
                    language: "en-US",
                    title: "English",
                },
                {
                    language: "he-IL",
                    title: "Hebrew",
                },
            ],
            windowWidth: window.innerWidth,
        };
    },
    mounted() {
        window.addEventListener("resize", this.updateWindowWidth);
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.updateWindowWidth);
    },
    methods: {
        updateWindowWidth() {
            this.windowWidth = window.innerWidth;
        },
        switchingRole(role) {
            const user = JSON.parse(getStorage(`auth`)) || {};
            if (user && user.role) {
                user.role = role;
                setStorage(`auth`, JSON.stringify(user));
                this.$store.dispatch("user", user);
                refresh();
            }
        },
        setLanguage(locale, country) {
            this.text = country;
            this.$store.commit('CHANGE_SETTING', locale);
            const isRTL = locale === "he-IL";
            this.$store.dispatch("setIsRTL", isRTL);
            setStorage(`locale`, locale);
            refresh();
        },
        toggleSidebar() {
            this.$emit('toggle-sidebar');
        },
        async handleSubmitLogout() {
            const adminRole = hasRole('admin');

            try {
                const response = await request({
                    method: 'post',
                    url: adminRole ? `/admin/logout` : `/user/logout`,
                });

                removeStorage('auth');

                await this.$store.dispatch('user', null);
                await this.$store.dispatch('setUnAuthorized', true);

                if (!adminRole) {
                    await this.$router.push({ name: 'Login' });
                } else {
                    await this.$router.push({ name: 'Login' });
                }

            } catch (error) {
                this.notifyError();
            }
        },
    },
};
</script>

<style scoped>
.app-header {
    z-index: 1000 !important;
    position: relative;
}

.hide-header {
    display: none;
}
</style>